namespace $.$$ {
	$mol_style_define( $shm_hitalama_components_history, {
		width: '30rem', maxWidth: '100%', flex: { grow: 0, shrink: 0, basis: '30rem' },
		Entry: { minWidth: 0, maxWidth: '100%', whiteSpace: 'normal', overflowWrap: 'anywhere' },
	})
}
